import AutoSubmit from '@stimulus-components/auto-submit'

export default class extends AutoSubmit {
  static targets = ['url']
  static values = {
    updateUrl: { type: Boolean, default: false },
    reloadId: { type: String },
    submit: { type: String, default: '' }
  }

  timeout = null

  initialize () {
    super.initialize()
    this.performSubmit = this.performSubmit.bind(this)
  }

  connect () {
    if (this.reloadIdValue) {
      this.bindReloadFrameWithId = this.reloadFrameWithId.bind(this)
      this.element.addEventListener('turbo:submit-end', this.bindReloadFrameWithId)
    }

    this.element.addEventListener('focusin', (e) => {
      if (e.target.matches('input, select, textarea')) {
        const input = e.target
        if (input.type === 'checkbox' || input.type === 'radio') {
          input.dataset.oldChecked = input.checked
        } else {
          input.dataset.oldValue = input.value
        }
      }
    })
  }

  disconnect () {
    if (this.reloadIdValue) { this.element.removeEventListener('turbo:submit-end', this.bindReloadFrameWithId) }

    super.disconnect()
  }

  cancel () {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }

  submit (event) {
    this.cancel()
    const input = event?.target
    if (!input) return

    const wasChecked = input.dataset.oldChecked === 'true'
    const valueChanged = input.type === 'checkbox' || input.type === 'radio'
      ? wasChecked !== input.checked
      : input.dataset.oldValue !== input.value

    if (!valueChanged) { return }
    this.timeout = setTimeout(this.performSubmit, this.delayValue)
  }

  performSubmit () {
    if (this.updateUrlValue) { this.updateHistory() }

    if (this.submitValue === 'inline') {
      this.element.querySelectorAll('.input').forEach(elem => {
        elem.classList.add('input-info-pulse')
      })
      this.element.querySelectorAll('input').forEach(elem => {
        elem.setAttribute('readonly', true)
      })
    }

    this.element.requestSubmit()
  }

  updateHistory () {
    const url = new URL(this.element.action)

    this.urlTargets.forEach((elem) => {
      if (elem.type !== 'radio' || elem.checked) {
        if (elem.value) { url.searchParams.append(elem.name, elem.value) }
      }
    })

    // eslint-disable-next-line no-undef
    history.replaceState({}, null, url.toString())
  }

  reloadFrameWithId () {
    document.getElementById(this.reloadIdValue).reload()
  }
}
